import { render, staticRenderFns } from "./DeferredPayment.vue?vue&type=template&id=6e75bc2b&"
import script from "./DeferredPayment.vue?vue&type=script&lang=ts&"
export * from "./DeferredPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports